import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Flex, Button, Text } from 'atoms';
import { userLogout } from 'store/userSlice';
import { setShowLogout, setinvoiceDate } from 'store/appSlice';
import { GetFullName } from 'utils';

export default function Logout() {
	const dispatch = useDispatch();
	const { showLogout } = useSelector((state) => state.app);

	const handleCancel = () => {
		dispatch(setShowLogout(false));
	};

	const handleOk = () => {
		handleCancel();
		dispatch(setinvoiceDate());
		dispatch(userLogout());
	};

	const { me = {} } = useSelector((state) => state.user);

	return (
		<Modal width={255} footer={null} visible={showLogout} closable={false} centered>
			<Text textAlign="center" fontSize="14px" id="logout-text">
				Hey {GetFullName.userFullName(me)}, are you sure want to logout ?
			</Text>
			<Flex alignItems="center" className="mt-15" flexDirection="column">
				<Button variant="primary" p={2} mt={1} mb={3} block onClick={() => handleOk()}>
					Ok
				</Button>
				<Button variant="outlinePrimary" p={2} block onClick={() => handleCancel()}>
					Cancel
				</Button>
			</Flex>
		</Modal>
	);
}
